module.exports = __webpack_public_path__ + "static/media/TORT.e64734f2.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/books/TORT.jpg
// module id = 1781
// module chunks = 1